var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorShield = function SvgErrorShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2458",
    d: "M7 10a.667.667 0 0 1-.667-.667V4a.667.667 0 0 1 1.333 0v5.333A.667.667 0 0 1 7 10Zm.528 5.84c1.44-.579 6.138-2.854 6.138-7.811V4.58a3.328 3.328 0 0 0-2.284-3.164L7.21.034a.657.657 0 0 0-.42 0L2.617 1.417A3.329 3.329 0 0 0 .333 4.581V8.03c0 4.374 4.67 7.05 6.102 7.766.181.087.37.155.565.205.18-.037.357-.09.528-.16Zm3.434-13.157a2 2 0 0 1 1.371 1.898V8.03c0 4.122-4.058 6.074-5.302 6.574-1.259-.63-5.365-2.964-5.365-6.574V4.58a2 2 0 0 1 1.371-1.898L7 1.369l3.962 1.314ZM7 11.333a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333Z"
  })));
};
export default SvgErrorShield;